import * as Sentry from "@sentry/react";

/**
 * Custom before send handler for Sentry events.
 * This function modifies the event data before it is sent to Sentry.
 */
export function onBeforeSend(event: Sentry.ErrorEvent) {
  event.breadcrumbs?.forEach((e) => {
    if (e.category === "fetch" && e.data?.url) {
      e.data = { ...e.data, url: e.data.url.split("?")[0] };
    }
    if (e.category === "navigation" && e.data?.to && e.data?.from) {
      e.data = {
        ...e.data,
        to: e.data.to.split("?")[0],
        from: e.data.from.split("?")[0],
      };
    }
  });

  if (event.request?.url) {
    event.request = {
      ...event.request,
      url: event.request.url.split("?")[0],
    };
  }
  return event;
}
